const CustomMenu = (props) => {
	let { children, cx, getStyles, innerRef, innerProps, } = props;

	const styles = getStyles("menu", props);

	return (
		<div
			style={{
				...styles,
                zIndex: 1000,
			}}
			className={cx({
				menu: true,
			})}
			ref={innerRef}
			{...innerProps}
		>
			{children}
		</div>
	);
};

export { CustomMenu };
